import { render, staticRenderFns } from "./CampusShuttle.vue?vue&type=template&id=543a4736&"
import script from "./CampusShuttle.vue?vue&type=script&lang=js&"
export * from "./CampusShuttle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports